import apiClient from "services/apiClient";

async function readAllNotifications() {
  const res = await apiClient.post(`/admin/notifications/read-all`);
  return res.data;
}

export default readAllNotifications;
